import svg from './row-svg/resynchronisation.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ResynchronisationIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default ResynchronisationIcon;
